import { lenis } from './animations';

export const initSmoothScroll = () => {
  function triggerBackToTop() {
    const backToTopButton = document.querySelector('.js-b2t');

    if (!backToTopButton) return;

    backToTopButton.addEventListener("click", () => {
      lenis.scrollTo(0);
    });
  }

  function anchorScroll() {
    document.querySelectorAll('a[href*="#"]:not([href="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        const url = new URL(anchor.href)

        if (url.pathname === window.location.pathname && url.hash) {
          e.preventDefault()

          lenis.scrollTo(url.hash, {
            offset: -50,
          })
        }
      });
    });
  }

  return {
    init() {
      triggerBackToTop();
      anchorScroll();
    },
  }
}
